import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import '../styles/pages/gallery.css';

const MODEL_ENDPOINTS = [
    "tasche",
    "guertel",
    "portmoney",
    "key",
    "accessory",
    "handy",
    "sonstige"
];

function ProductGallery() {
    const { product_id } = useParams();
    const [product, setProduct] = useState(null);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProduct = async () => {
            for (let endpoint of MODEL_ENDPOINTS) {
                try {
                    const res = await axios.get(`https://nurleder.de/api/${endpoint}/${product_id}/`);
                    if (res.status === 200) {
                        setProduct(res.data);
                        const firstImage = res.data.images?.[0]?.image || null;
                        setSelectedMedia(firstImage);
                        setLoading(false);
                        return;
                    }
                } catch (err) {
                    // ignore
                }
            }
            setLoading(false);
        };

        fetchProduct();
    }, [product_id]);

    if (loading) return <div className="gallery-page"><p>Lade Produktdaten...</p></div>;
    if (!product) return <div className="gallery-page"><p>❌ Produkt nicht gefunden</p></div>;

    const scrollThumbnails = (direction) => {
        const row = document.getElementById("thumb-row");
        if (row) {
            row.scrollBy({
                left: direction * 80,
                behavior: "smooth",
            });
        }
    };

    const isVideo = selectedMedia?.endsWith('.mp4');

    return (
        <section className="gallery-page">
            <h2>{product.name}</h2>

            <div className="gallery-main-image">
                {isVideo ? (
                    <video src={selectedMedia} controls autoPlay style={{ width: "100%" }} />
                ) : (
                    <img src={selectedMedia} alt="Ausgewählt" />
                )}
            </div>

            <div className="thumbnail-carousel-wrapper">
                <button onClick={() => scrollThumbnails(-1)} className="scroll-btn">◀</button>
                <div className="thumbnail-scroll-container">
                    <div className="thumbnail-row" id="thumb-row">
                        {product.images.map((img, i) => (
                            <img
                                key={i}
                                src={img.image}
                                alt={`thumb-${i}`}
                                className={`thumbnail ${selectedMedia === img.image ? "active" : ""}`}
                                onClick={() => setSelectedMedia(img.image)}
                            />
                        ))}

                        {/* Video-Thumbnail mit Play-Overlay */}
                        {product.video && (
                            <div
                                className={`thumbnail video-thumb ${selectedMedia === product.video ? "active" : ""}`}
                                onClick={() => setSelectedMedia(product.video)}
                            >
                                <video src={product.video} muted playsInline loop className="video-element" />
                                <div className="play-icon">▶</div>
                            </div>
                        )}
                    </div>
                </div>
                <button onClick={() => scrollThumbnails(1)} className="scroll-btn">▶</button>
            </div>

            <div>
                <p>Name: {product.name}</p>
                <p>Description: {product.description}</p>
                <p>Farbe: {product.colors}</p>
            </div>
        </section>
    );
}

export default ProductGallery;
